import { defineStore } from 'pinia';
import { ref } from 'vue';

export interface AppContext {
  isShell: boolean;
  isMicroFrontend: boolean;
  basePath: string;
  remoteOrigin?: string | null;
}

export const useContextStore = defineStore('context', () => {
  const isShell = ref(false);
  const isMicroFrontend = ref(false);
  const basePath = ref('');
  const remoteOrigin = ref<string | null>(null);

  // Methods
  function setContext(context: AppContext) {
    isShell.value = context.isShell;
    isMicroFrontend.value = context.isMicroFrontend;
    basePath.value = context.basePath;
    if (context.remoteOrigin !== undefined) {
      remoteOrigin.value = context.remoteOrigin;
    }
  }

  function shellBasePathForDeployment(waapDeploymentId?: string | null): string {
    if (waapDeploymentId && String(waapDeploymentId).length > 0) {
      return `/waap/${waapDeploymentId}`;
    }
    return '/waap';
  }

  function initializeFromShell(
    remoteOriginParam?: string | null,
    waapDeploymentIdParam?: string | null
  ) {
    const context: AppContext = {
      isShell: true,
      isMicroFrontend: true,
      basePath: shellBasePathForDeployment(waapDeploymentIdParam),
      remoteOrigin: remoteOriginParam || null,
    };
    setContext(context);
  }

  function initializeAsSPA() {
    const context: AppContext = {
      isShell: false,
      isMicroFrontend: false,
      basePath: '',
    };
    setContext(context);
  }

  return {
    isShell,
    isMicroFrontend,
    basePath,
    remoteOrigin,
    initializeFromShell,
    initializeAsSPA,
    setContext,
  };
});
